<script>
import { bankingTransactionsQris as columns } from "../../../../tables";

export default {
  name: "h-limit-transaction-setting",
  props: {
    path: {
      type: String,
      default: ""
    }
  },
  computed: {
    uri() {
      return this.path !== ""
        ? this.path
        : this.routeUri("hyperion.lakupandai.limit-transactions.index");
    },
    filteredRanges: {
      get() {
        return this.filters.date.map(o => this.moment(o, "YYYY-MM-DD"));
      },
      set(val) {
        this.filters.date = val.map(moment => moment.format("YYYY-MM-DD"));
      }
    },
    pageSize() {
      return parseInt(this.items.per_page);
    },
    rules() {
      return {
        "config.0.min_limit": [
          {
            required: true,
            message: "Setoran Tunai minimal is required",
            trigger: "blur"
          },
          { validator: this.validateMinLimit, trigger: "blur" }
        ],
        "config.0.max_limit": [
          {
            required: true,
            message: "Setoran Tunai maksimal is required",
            trigger: "blur"
          },
          { validator: this.validateMaxLimit, trigger: "blur" }
        ],
        "config.1.min_limit": [
          {
            required: false,
            message: "Tarik Tunai minimal is required",
            trigger: "blur"
          },
          { validator: this.validateMinLimit, trigger: "blur" }
        ],
        "config.1.max_limit": [
          {
            required: false,
            message: "Tarik Tunai maksimal is required",
            trigger: "blur"
          },
          { validator: this.validateMaxLimit, trigger: "blur" }
        ]
      };
    }
  },
  data() {
    return {
      form: null,
      columns,
      items: {},
      loading: {
        dataset: false,
        item: false,
        submit: false
      },
      expand: false,
      loadingDownload: false,
      isEditing: false,
      config: [
        {
          id: 1,
          min_limit: '0',
          max_limit: '0'
        },
        {
          id: 2,
          min_limit: '0',
          max_limit: '0'
        }
      ]
    };
  },
  created() {
    this.form = this.$form.createForm(this, { name: "limit_config" });
    this.items = this.getDefaultPagination();
    this.filters = _.merge(this.filters, this.$hyperion.request);
    this.getItems();
  },
  methods: {
    handleAutocomplete(v, iteratee) {
      if (v.length === 0) {
        this.filters[iteratee] = [];
      } else {
        this.filters[iteratee] = _.map(v, o => o.id);
      }
    },
    handleReset(e) {
      e.preventDefault();
      this.filters = {
        page: 1,
        per_page: 10,
        terminal_id: "",
        merchant_id: "",
        service: "",
        merchant_name: "",
        q: "",
        date: []
      };
    },
    tableChanged(pagination) {
      this.filters.page = pagination.current;
      this.filters.per_page = pagination.pageSize;
      this.pushState(this.filters);
      this.getItems();
    },
    handleSubmit(e) {
      e.preventDefault();

      this.$refs.configForm.validate(valid => {
        if (valid) {
          this.loading.submit = true;

          this.$http
            .post(this.routeUri("hyperion.lakupandai.limit-transactions.store"), {
              config: this.config
            })
            .then(() => {
              this.handleSuccessResponse();
              this.isEditing = false;
              this.$refs.configForm.clearValidate();
            })
            .catch(error => this.handleXhrError(error))
            .finally(() => (this.loading.submit = false));
        }
      });
    },
    getItems() {
      this.loading.dataset = true;
      this.$http
        .get(this.routeUri(this.uri, {}, true), {
          params: this.filters
        })
        .then(response => {
          this.items = response.data;
          // Gunakan cloneDeep agar config dan items tidak saling memengaruhi
          this.config = _.cloneDeep(this.items);
        })
        .catch(error => this.handleXhrError(error))
        .finally(() => (this.loading.dataset = false));
    },
    handleEdit() {
      this.isEditing = !this.isEditing;
    },
    handleSuccessResponse(data) {
      this.$notification.success({
        message: "Success",
        description: "Data updated."
      });
    },
    validateMinLimit(rule, value, callback) {
      const index = rule.field.includes("config.0") ? 0 : 1;
      const maxValue = this.config[index].max_limit;

      if (value && maxValue && value >= maxValue) {
        callback(
          new Error("Nilai minimum tidak boleh sama atau lebih dari maksimum")
        );
      } else {
        callback();
      }
    },
    validateMaxLimit(rule, value, callback) {
      const index = rule.field.includes("config.0") ? 0 : 1;
      const minValue = this.config[index].min_limit;

      if (value && minValue && value <= minValue) {
        callback(new Error("Nilai maksimum harus lebih besar dari minimum"));
      } else {
        callback();
      }
    }
  }
};
</script>

<template>
  <a-card
    size="small"
    type="inner"
    :title="
      items.total > 0
        ? 'Limit Transaction Laku Pandai ' + items.total + ' record(s)'
        : 'Limit Transaction Laku Pandai'
    "
  >
    <a-form-model :model="{ config }" :rules="rules" ref="configForm">
      <a-form-item class="flex justify-end">
        <a-button type="secondary" html-type="button" @click="handleEdit">
          {{ isEditing ? "Cancel" : "Edit Data" }}
        </a-button>
      </a-form-item>
      <div>
        <p class="font-bold text-lg">Setoran Tunai</p>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item label="Minimal" prop="config.0.min_limit">
              <a-input-number
                :disabled="!isEditing"
                v-model="config[0].min_limit"
                placeholder="0"
                style="width: 100%"
                :min="0"
                :formatter="
                  value => {
                    if (!value && value !== 0) return '';
                    return `Rp ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
                  }
                "
                :parser="value => value.replace(/[^\d]/g, '')"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="Maksimal" prop="config.0.max_limit">
              <a-input-number
                :disabled="!isEditing"
                v-model="config[0].max_limit"
                placeholder="0"
                style="width: 100%"
                :min="0"
                :formatter="
                  value => {
                    if (!value && value !== 0) return '';
                    return `Rp ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
                  }
                "
                :parser="value => value.replace(/[^\d]/g, '')"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
      </div>

      <div>
        <p class="font-bold text-lg">Tarik Tunai</p>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item label="Minimal" prop="config.1.min_limit">
              <a-input-number
                :disabled="!isEditing"
                v-model="config[1].min_limit"
                placeholder="0"
                style="width: 100%"
                :min="0"
                :formatter="
                  value => {
                    if (!value && value !== 0) return '';
                    return `Rp ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
                  }
                "
                :parser="value => value.replace(/[^\d]/g, '')"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="Maksimal" prop="config.1.max_limit">
              <a-input-number
                :disabled="!isEditing"
                v-model="config[1].max_limit"
                placeholder="0"
                style="width: 100%"
                :min="0"
                :formatter="
                  value => {
                    if (!value && value !== 0) return '';
                    return `Rp ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
                  }
                "
                :parser="value => value.replace(/[^\d]/g, '')"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
      </div>

      <a-form-item class="flex justify-end">
        <a-button
          type="primary"
          :disabled="!isEditing"
          :loading="loading.submit"
          @click="handleSubmit"
          >Submit</a-button
        >
      </a-form-item>
    </a-form-model>
  </a-card>
</template>
